import apiFetch from '../apiFetch'
export default function (token, unattendedProcessId) {
  return apiFetch({ endPoint: `UnattendedProcess/${unattendedProcessId}/OperateActionPrintDeliveryNote`, method: 'GET', token: token, parseBlobAndAssign: true })
}
